import React from 'react';
import clsx from "clsx";

export default function PhoneHoursDisplay({
  phoneNumber, caption, openNow = false
}) {
  // call-now is used elsewhere for screen-scraping
  const classNames = clsx("text-right leading-tight");

  // id main-phone-number is used by SkuTooltip to screenscrape
  return <div className={classNames}>
    <OpenNowCaption openNow={openNow} caption={caption}/>
    <div id="main-phone-number" className="text-brand-blue text-xl font-bold leading-none">
      {phoneNumber}</div>
  </div>
}

function OpenNowCaption({openNow = false, caption}) {
  caption ||= '7 days/week';

  // default caption is "7 Days/Week"
  if (!openNow)
    return <div className="text-sm leading-tight">{caption}</div>;

  const styles = {
    animation: "fade-in-out-half 4s infinite"
  }

  return <span className="text-xs text-brand-orange leading-none uppercase font-bold"
    style={styles}>
      Phone Lines are Open
    {' '} <em className="underline">NOW</em>!
    </span>

}
